// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__fqTYj","tabsContainer":"tabs_tabsContainer__UgGNu","active":"tabs_active__GlsiP","contentContainer":"tabs_contentContainer__vYtLG"};